// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
import { ChatListToolboxModal } from './chat-list-toolbox-modal'

const TOOLBOX_COMPONENT_ID = 'chat-list-toolbox'

export const showChatListToolboxModal = () =>
  addModal({ id: TOOLBOX_COMPONENT_ID })

export default {
  [TOOLBOX_COMPONENT_ID]: {
    Component: ChatListToolboxModal,
  },
}
